import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import SignaturePad, { PointGroup } from 'signature_pad';
import * as signLine from '../../../assets/data/line-sign.json';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss'],
})
export class SignatureComponent implements OnChanges, AfterViewInit {
  @Input() show = false;

  @Input() getSignature = false;

  @Output() data = new EventEmitter<string>();

  @Output() propagar = new EventEmitter<boolean>();

  signature!: SignaturePad;

  undoData: any = [];

  currentWithSign = 1;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.getSignature?.currentValue) {
      this.saveSign();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const signatureCanvas = document.querySelector('#signature-pad') as HTMLCanvasElement;
      if (signatureCanvas) {
        this.signature = new SignaturePad(signatureCanvas);
        this.signature?.addEventListener('endStroke', () => {
          this.undoData = [];
        });
        this.setWidthSignPencil(this.currentWithSign);
      }
    }, 500);
  }

  undoSign() {
    const data = this.signature?.toData();
    if (data && data.length > 0) {
      const removed = data.pop();
      this.undoData.push(removed);
      this.signature?.fromData(data);
    }
  }

  redoSign() {
    const data = this.signature?.toData();
    if (data && this.undoData.length > 0) {
      data.push(this.undoData.pop());
      this.signature?.fromData(data);
    }
  }

  setWidthSignPencil(width: number) {
    if (!this.signature) return;
    this.currentWithSign = width;
    this.signature.minWidth = width;
    this.signature.maxWidth = width;
  }

  clearSign() {
    this.signature?.clear();
  }

  saveSign() {
    const data = this.signature?.toData();
    if (!data) return;
    data.push(signLine as PointGroup);
    this.signature?.fromData(data);
    this.data.emit(this.signature?.toDataURL());
  }

  cancel() {
    this.show = !this.show;
    this.propagar.emit(this.show);
  }
}
